export type TLinks =
  | '/'
  | '/contacts/timeline'
  | '/contacts/people'
  | '/contacts/company'
  | '/contacts/lead'
  | '/contacts/lead/archived'
  | '/contacts/deal'
  | '/contacts/ticket'
  | '/contacts/tasks'
  | '/contacts/invoice'
  | '/contacts/invoice/form'
  | '/contacts/invoice/setting'
  | '/contacts/whatsapp'
  | '/contacts/whatsappMessages'
  | '/contacts/products'
  | '/contacts/inventory'
  | '/report/missedCalls'
  | '/report/hangupReason'
  | '/report/calls'
  | '/report/operatorActivity'
  | '/report/cdr'
  | '/report/fullCdrs'
  | '/report/rating'
  | '/report/scatteirng'
  | '/report/cost'
  | '/report/waiting'
  | '/monitoring/dashboard'
  | '/monitoring/wallboard'
  | '/monitoring/call'
  | '/send/phone-book'
  | '/send/phone-book/groups'
  | '/send/send-single'
  | '/send/send-single/edit'
  | '/send/groups'
  | '/send/groups/create'
  | '/send/groups/edit'
  | '/send/bulk'
  | '/send/bulk/edit'
  | '/send/corresponding'
  | '/send/parametric'
  | '/send/otp'
  | '/send/report-send'
  | '/send/report-receive'
  | '/Webchat/dashboard'
  | '/Webchat/settings'
  | '/Webchat/number'
  | '/Webchat/user'
  | '/Webchat/department'
  | '/Webchat/customize'
  | '/Webchat/conversations'
  | '/evaluation/save'
  | '/evaluation/save/form'
  | '/evaluation/save/edit'
  | '/evaluation/save/view'
  | '/evaluation/report'
  | '/evaluation/user'
  | '/fax/insert'
  | '/fax/send'
  | '/fax/submitted'
  | '/fax/received'
  | '/automation/workflow'
  | '/automation/reports'
  | '/videoConference/createLink'
  | '/videoConference/report'
  | '/users/operator'
  | '/users/department'
  | '/users/access'
  | '/users/message'
  | '/users/whatsapp'
  | '/users/whatsappMessages'
  | '/settings/forward'
  | '/settings/recording'
  | '/settings/queue'
  | '/settings/ivr'
  | '/settings/timeCondition'
  | '/settings/voiceMail'
  | '/settings/blackList'
  | '/settings/destination'
  | '/settings/rating'
  | '/settings/callRecording'
  | '/settings/callRatings'
  | '/setting/lead'
  | '/setting/people'
  | '/setting/companies'
  | '/crm/numbers'
  | '/crm/settings'
  | '/crm/links'
  | '/support/send'
  | '/support/tickets'
  | '/notification'
  | '/reports/lead'
  | '/reports/deal'
  | '/reports/task'
  | '/reports/ticket'
  | '/setting/ticket';

export type TNoLink = 'users/stream_record_sound';

export type TVisibility =
  | 'open_to_all' // used for ignoring the permission check - not exists in the database
  | 'userid'
  | 'fax'
  | 'callcenter'
  | 'webchat'
  | 'sms'
  | 'SMSParametricAndPointToPoint'
  | 'smsotp'
  | 'listRoles'
  | 'ManageRoles'
  | 'messageOpt'
  | 'callfrwdNumDef'
  | 'timeCond'
  | 'voiceMan'
  | 'hangupStatus'
  | 'answeredCalls'
  | 'nAnsCal'
  | 'optActivity'
  | 'recCalLg'
  | 'advLgs'
  | 'rateLogs'
  | 'scatRep'
  | 'wallboard'
  | 'liveCalMon'
  | 'support'
  | 'crm'
  | 'ci'
  | 'qaqc'
  | 'videoconf'
  | 'whatsApp'
  | 'factor'
  | 'product'
  | 'inventory'
  | 'lead'
  | 'deal'
  | 'ticket'
  | 'timeline'
  | 'automation'
  | 'record_call'
  | 'sms_provider'
  | 'rating_call';

export type TAccess =
  | 'open_to_all' // used for ignoring the permission check - not exists in the database
  | 'add_user'
  | 'block_list'
  | 'call'
  | 'call_forward'
  | 'call_logs'
  | 'call_records'
  | 'call_report_unanswerd'
  | 'call_scattering'
  | 'ci_companies'
  | 'ci_persons'
  | 'conf_create_link'
  | 'conf_report'
  | 'cost_log'
  | 'create_tickets'
  | 'crm_authorized_numbers'
  | 'crm_links'
  | 'crm_settings'
  | 'customer_waiting'
  | 'deal'
  | 'department'
  | 'destinations'
  | 'evaluation_report'
  | 'evaluations'
  | 'fax_create'
  | 'fax_recv_report'
  | 'fax_send'
  | 'fax_sent_report'
  | 'full_call_records'
  | 'inventory'
  | 'invoice'
  | 'invoice_settings'
  | 'ivr_menu'
  | 'lead'
  | 'sms_contacts'
  | 'sms_single_send'
  | 'sms_group_send'
  | 'sms_bulk_send'
  | 'sms_p2p_send'
  | 'sms_parametric_send'
  | 'sms_developers_section'
  | 'sms_inbounds'
  | 'sms_messages_detail'
  | 'live_monitoring'
  | 'message_bulk'
  | 'message_corresponding'
  | 'message_group'
  | 'message_otp'
  | 'message_parametric'
  | 'message_receive_report'
  | 'message_send_report'
  | 'message_single'
  | 'message_to_operator'
  | 'observe_sent_tickets'
  | 'operators_activity'
  | 'product'
  | 'queue'
  | 'rating'
  | 'role_management'
  | 'task'
  | 'ticket'
  | 'time_cond'
  | 'permission_management'
  | 'upload_voice'
  | 'voicemail_management'
  | 'wallboard'
  | 'webchat_operator_management'
  | 'webchat_chats' // گفتگوها
  | 'webchat_counter' // پیشخوان
  | 'webchat_declare_website' // تعریف وبسایت
  | 'webchat_department' // تعریف دپارتمان‌ها
  | 'webchat_personalization' // تنظیمات و شخصی‌سازی
  | 'whatsapp'
  | 'stream_record_sound'
  | 'call_report_missed'
  | 'timeline'
  | 'workflow'
  | 'rating_call'
  | 'ticket_board'
  | 'sms_provider'
  | 'record_call';

export type TPermission = 'add' | 'delete' | 'edit' | 'view';
export type TPolicy =
  | 'self'
  | 'self_and_role_mates'
  | 'self_and_department_mates'
  | 'all';

// 🎯 extendable custom permissions
export type TCustomPermission =
  | 'assign'
  | 'convert'
  | 'create_category'
  | 'delete_category'
  | 'edit_category'
  | 'report'
  | 'upload'
  | 'close'
  | 'answer'
  | 'change_status'
  | 'delete_agent'
  | 'comment'
  | 'add_product'
  | 'invoke'
  | 'add_pre_invoice'
  | 'delete_group'
  | 'edit_group'
  | 'view_group'
  | 'add_group'
  | 'title_options';

export type TNoPolicyPermission = (TPermission | TCustomPermission) &
  (
    | 'add'
    | 'report'
    | 'delete_agent'
    | 'create_category'
    | 'delete_category'
    | 'edit_category'
    | 'add_product'
    | 'upload'
  );

export type TAccessGroup =
  | 'crm'
  | 'reportsRAP'
  | 'wallboard'
  | 'sms'
  | 'webchat'
  | 'qaqc'
  | 'fax'
  | 'videoConference'
  | 'callSettings'
  | 'connectToCrm'
  | 'userSettings'
  | 'automation'
  | 'ticketSettings';
// | 'settings';

const accessEntries: [
  TLinks | TNoLink,
  { user: TAccess[]; owner: TVisibility[] },
][] = [
  // Crm
  ['/contacts/timeline', { user: ['timeline'], owner: ['timeline'] }],
  ['/contacts/people', { user: ['ci_persons'], owner: ['ci'] }],
  ['/contacts/company', { user: ['ci_companies'], owner: ['ci'] }],
  ['/contacts/whatsapp', { user: [], owner: ['whatsApp'] }],
  ['/contacts/whatsappMessages', { user: ['whatsapp'], owner: ['whatsApp'] }],
  ['/contacts/products', { user: ['product'], owner: ['product'] }],
  ['/contacts/invoice', { user: ['invoice'], owner: ['factor'] }],
  ['/contacts/invoice/form', { user: ['invoice'], owner: ['factor'] }],
  [
    '/contacts/invoice/setting',
    { user: ['invoice_settings'], owner: ['factor'] },
  ],
  ['/contacts/inventory', { user: ['inventory'], owner: ['inventory'] }],
  ['/contacts/lead', { user: ['lead'], owner: ['lead'] }],
  ['/contacts/lead/archived', { user: ['lead'], owner: ['lead'] }],
  ['/contacts/tasks', { user: ['task'], owner: ['ci'] }],
  ['/contacts/ticket', { user: ['ticket'], owner: ['ticket'] }],
  ['/contacts/deal', { user: ['deal'], owner: ['deal'] }],

  // Webchat
  [
    '/Webchat/settings',
    { user: ['webchat_declare_website'], owner: ['webchat'] },
  ],
  ['/Webchat/number', { user: [], owner: ['webchat'] }],
  [
    '/Webchat/user',
    { user: ['webchat_operator_management'], owner: ['webchat'] },
  ],
  ['/Webchat/department', { user: ['webchat_department'], owner: ['webchat'] }],
  [
    '/Webchat/customize',
    { user: ['webchat_personalization'], owner: ['webchat'] },
  ],
  ['/Webchat/conversations', { user: ['webchat_chats'], owner: ['webchat'] }],
  // ['/Webchat/dashboard', { user: ['webchat_counter'], owner: ['webchat'] }],

  // VideoConference
  [
    '/videoConference/createLink',
    { user: ['conf_create_link'], owner: ['videoconf'] },
  ],
  ['/videoConference/report', { user: ['conf_report'], owner: ['videoconf'] }],

  // Notification
  ['/notification', { user: ['open_to_all'], owner: ['open_to_all'] }],

  // Reports
  ['/reports/ticket', { user: ['ticket'], owner: ['ticket'] }],
  ['/reports/lead', { user: ['lead'], owner: ['lead'] }],
  ['/reports/deal', { user: ['deal'], owner: ['deal'] }],
  ['/reports/task', { user: ['task'], owner: ['ci'] }],

  // Users
  ['/users/operator', { user: ['role_management'], owner: ['callcenter'] }],
  ['/users/department', { user: ['department'], owner: ['callcenter'] }],
  [
    '/users/access',
    { user: ['permission_management'], owner: ['ManageRoles'] },
  ],
  ['/users/message', { user: ['message_to_operator'], owner: ['messageOpt'] }],
  ['/users/whatsapp', { user: ['whatsapp'], owner: ['whatsApp'] }],
  ['/users/whatsappMessages', { user: ['whatsapp'], owner: ['ci'] }],
  [
    'users/stream_record_sound',
    {
      user: ['stream_record_sound'],
      owner: ['recCalLg', 'advLgs', 'voiceMan'],
    },
  ],

  // Report
  ['/report/missedCalls', { user: ['call_report_missed'], owner: ['nAnsCal'] }],
  ['/report/hangupReason', { user: ['call_logs'], owner: ['hangupStatus'] }],
  ['/report/calls', { user: ['call_report_unanswerd'], owner: ['nAnsCal'] }],
  [
    '/report/operatorActivity',
    { user: ['operators_activity'], owner: ['optActivity'] },
  ],
  ['/report/cdr', { user: ['call_records'], owner: ['recCalLg'] }],
  ['/report/fullCdrs', { user: ['full_call_records'], owner: ['advLgs'] }],
  ['/report/scatteirng', { user: ['call_scattering'], owner: ['scatRep'] }],
  ['/report/rating', { user: ['rating'], owner: ['rateLogs'] }],
  ['/report/cost', { user: ['cost_log'], owner: ['callcenter'] }],
  ['/report/waiting', { user: ['customer_waiting'], owner: ['advLgs'] }],

  // QAQC
  ['/evaluation/save', { user: ['evaluations'], owner: ['qaqc'] }],
  ['/evaluation/save/form', { user: ['evaluations'], owner: ['qaqc'] }],
  ['/evaluation/save/edit', { user: ['evaluations'], owner: ['qaqc'] }],
  ['/evaluation/save/view', { user: ['evaluations'], owner: ['qaqc'] }],
  ['/evaluation/report', { user: ['evaluation_report'], owner: ['qaqc'] }],
  ['/evaluation/user', { user: ['evaluation_report'], owner: ['qaqc'] }],

  // Support
  ['/support/send', { user: ['create_tickets'], owner: ['support'] }],
  ['/support/tickets', { user: ['observe_sent_tickets'], owner: ['support'] }],

  // Fax
  ['/fax/insert', { user: ['fax_create'], owner: ['fax'] }],
  ['/fax/send', { user: ['fax_send'], owner: ['fax'] }],
  ['/fax/submitted', { user: ['fax_sent_report'], owner: ['fax'] }],
  ['/fax/received', { user: ['fax_recv_report'], owner: ['fax'] }],

  // Automation
  ['/automation/workflow', { user: ['workflow'], owner: ['automation'] }],

  // Connect To CRM
  ['/crm/numbers', { user: ['crm_authorized_numbers'], owner: ['crm'] }],
  ['/crm/settings', { user: ['crm_settings'], owner: ['crm'] }],
  ['/crm/links', { user: ['crm_links'], owner: ['crm'] }],

  // Monitoring
  ['/monitoring/dashboard', { user: ['open_to_all'], owner: ['open_to_all'] }],
  ['/monitoring/wallboard', { user: ['wallboard'], owner: ['wallboard'] }],
  ['/monitoring/call', { user: ['live_monitoring'], owner: ['liveCalMon'] }],

  // SMS
  ['/send/phone-book', { user: ['sms_contacts'], owner: ['sms'] }],
  ['/send/phone-book/groups', { user: ['sms_contacts'], owner: ['sms'] }],
  ['/send/send-single', { user: ['sms_single_send'], owner: ['sms'] }],
  ['/send/send-single/edit', { user: ['sms_single_send'], owner: ['sms'] }],
  ['/send/report-send', { user: ['sms_messages_detail'], owner: ['sms'] }],
  ['/send/report-receive', { user: ['sms_inbounds'], owner: ['sms'] }],
  ['/send/bulk', { user: ['sms_bulk_send'], owner: ['sms'] }],
  ['/send/bulk/edit', { user: ['sms_bulk_send'], owner: ['sms'] }],
  ['/send/groups', { user: ['sms_group_send'], owner: ['sms'] }],
  ['/send/groups/edit', { user: ['sms_group_send'], owner: ['sms'] }],
  [
    '/send/corresponding',
    {
      user: ['sms_p2p_send'],
      owner: ['SMSParametricAndPointToPoint'],
    },
  ],
  [
    '/send/parametric',
    { user: ['sms_parametric_send'], owner: ['SMSParametricAndPointToPoint'] },
  ],
  [
    '/send/otp',
    { user: ['sms_developers_section', 'sms_provider'], owner: ['smsotp'] },
  ],

  // Settings
  ['/settings/forward', { user: ['call_forward'], owner: ['callfrwdNumDef'] }],
  ['/settings/recording', { user: ['upload_voice'], owner: ['callcenter'] }],
  ['/settings/queue', { user: ['queue'], owner: ['callcenter'] }],
  ['/settings/ivr', { user: ['ivr_menu'], owner: ['callcenter'] }],
  ['/settings/timeCondition', { user: ['time_cond'], owner: ['timeCond'] }],
  [
    '/settings/voiceMail',
    { user: ['voicemail_management'], owner: ['voiceMan'] },
  ],
  ['/settings/blackList', { user: ['block_list'], owner: ['callcenter'] }],
  ['/settings/destination', { user: ['destinations'], owner: ['callcenter'] }],
  ['/settings/rating', { user: [], owner: ['callcenter'] }],
  [
    '/settings/callRecording',
    { user: ['record_call'], owner: ['record_call'] },
  ],
  ['/settings/callRatings', { user: ['rating_call'], owner: ['rating_call'] }],

  //setting
  ['/setting/ticket', { user: ['ticket_board'], owner: ['ticket'] }],
  ['/setting/lead', { user: ['lead'], owner: ['lead'] }],
  ['/setting/companies', { user: ['ci_companies'], owner: ['ci'] }],
  ['/setting/people', { user: ['ci_persons'], owner: ['ci'] }],
];

const accessToVisibilityMap = mapAccessToVisibility(accessEntries);

export const AccessMap: Partial<Record<TAccess, TVisibility>> =
  accessToVisibilityMap;
export const AccessEntries: Map<
  TLinks | TNoLink,
  { user: TAccess[]; owner: TVisibility[] }
> = new Map(accessEntries);

function mapAccessToVisibility(
  entries: typeof accessEntries
): Partial<Record<TAccess, TVisibility>> {
  const result: Partial<Record<TAccess, TVisibility>> = {};

  for (const [, { user, owner }] of entries) {
    const o = owner[0];
    if (!o) continue;
    for (const u of user) result[u] = o;
  }

  return result;
}
